/* =============================================================
   cdn-club-scroll.js — Club dei Nasi, versione «scroll» (/pages/il-club-dei-nasi), 23-09-2026.
   Tre cose, tutte dentro #ncs-top:
   1) «Come funziona» resta fermo mentre si scorre: lo scorrimento sceglie la tappa (01 → 02 → 03),
      il testo si riscrive a macchina e la foto cambia. I caratteri sono già tutti nella pagina
      (visibility) e si accendono uno per uno: niente riflusso, niente salti, le righe non cambiano mai.
      Il cursore è disegnato fuori dal flusso (position: absolute), così non sposta le lettere dopo.
   2) i filtri dei premi (uguali alla pagina definitiva);
   3) le altre righe del confronto fra i livelli.
   Chi ha chiesto meno animazioni (prefers-reduced-motion) vede il testo tutto insieme.
   ============================================================= */
(function () {
  var root = document.getElementById('ncs-top');
  if (!root) return;
  var fermo = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PARTI = ['.ncs-how__n', '.ncs-how__t', '.ncs-how__p'];
  var PASSI = { '.ncs-how__n': 80, '.ncs-how__t': 26, '.ncs-how__p': 11 };

  /* ---------- macchina da scrivere ---------- */
  function prepara(el) {
    if (el.getAttribute('data-tw')) return;
    var testo = el.textContent.replace(/\s+/g, ' ').trim();
    el.textContent = '';
    var pezzi = testo.split(/(\s+)/);
    for (var i = 0; i < pezzi.length; i++) {
      var p = pezzi[i];
      if (!p) continue;
      if (/^\s+$/.test(p)) {
        var spazio = document.createElement('i');
        spazio.textContent = ' ';
        el.appendChild(spazio);
        continue;
      }
      var parola = document.createElement('span');
      for (var j = 0; j < p.length; j++) {
        var c = document.createElement('i');
        c.textContent = p[j];
        parola.appendChild(c);
      }
      el.appendChild(parola);
    }
    el.classList.add('ncs-tw');
    el.setAttribute('data-tw', '1');
  }
  function lettere(el) { return Array.prototype.slice.call(el.getElementsByTagName('i')); }
  function spegni(el) {
    el.classList.remove('is-typing');
    lettere(el).forEach(function (c) { c.className = ''; });
  }
  function accendi(el) {
    el.classList.remove('is-typing');
    lettere(el).forEach(function (c) { c.className = 'is-on'; });
  }

  var giro = 0, orologio = null;
  function scrivi(lista, mio) {
    var i = 0, k = 0, chars = null;
    clearTimeout(orologio);
    (function passo() {
      if (mio !== giro || i >= lista.length) return;
      var el = lista[i].el;
      if (chars === null) { chars = lettere(el); el.classList.add('is-typing'); }
      if (k >= chars.length) {
        if (k > 0) chars[k - 1].classList.remove('is-cur');
        el.classList.remove('is-typing');
        i++; k = 0; chars = null;
        orologio = setTimeout(passo, 110);
        return;
      }
      if (k > 0) chars[k - 1].classList.remove('is-cur');
      chars[k].classList.add('is-on');
      chars[k].classList.add('is-cur');
      k++;
      orologio = setTimeout(passo, lista[i].passo);
    })();
  }

  /* ---------- «Come funziona»: lo scorrimento sceglie la tappa ---------- */
  var how = root.querySelector('[data-ncs-how]');
  if (how) {
    var pin = how.querySelector('.ncs-how__pin');
    var tappe = Array.prototype.slice.call(how.querySelectorAll('.ncs-how__step'));
    var foto = Array.prototype.slice.call(how.querySelectorAll('.ncs-how__img'));
    var barre = Array.prototype.slice.call(how.querySelectorAll('.ncs-how__bar i'));
    var conta = how.querySelector('[data-ncs-of]');
    tappe.forEach(function (t) {
      PARTI.forEach(function (sel) { var el = t.querySelector(sel); if (el) prepara(el); });
    });

    var attuale = -1, entrato = false;
    function scena(i) {
      tappe.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      foto.forEach(function (f, k) { f.classList.toggle('is-on', k === i); });
      barre.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
      if (conta) conta.textContent = '0' + (i + 1) + ' / 0' + tappe.length;
    }
    function mostra(i, subito) {
      if (i === attuale) return;
      attuale = i;
      giro++;
      var mio = giro;
      clearTimeout(orologio);
      tappe.forEach(function (t, k) {
        PARTI.forEach(function (sel) {
          var el = t.querySelector(sel);
          if (!el) return;
          if (k !== i) spegni(el); else if (subito || fermo) accendi(el); else spegni(el);
        });
      });
      scena(i);
      if (subito || fermo) return;
      var lista = [];
      PARTI.forEach(function (sel) {
        var el = tappe[i].querySelector(sel);
        if (el) lista.push({ el: el, passo: PASSI[sel] });
      });
      scrivi(lista, mio);
    }

    function aggiorna() {
      var r = how.getBoundingClientRect();
      var alto = pin.offsetHeight;
      var corsa = how.offsetHeight - alto;
      var su = parseFloat(window.getComputedStyle(pin).top) || 0;
      var avanti = corsa > 0 ? (su - r.top) / corsa : 0;
      var i = Math.floor(avanti * tappe.length);
      if (i < 0) i = 0;
      if (i > tappe.length - 1) i = tappe.length - 1;
      var dentro = r.top < window.innerHeight * 0.8 && r.bottom > window.innerHeight * 0.2;
      if (!dentro) {
        if (!entrato) mostra(0, true); // prima di arrivarci la prima tappa è già leggibile
        return;
      }
      if (!entrato) { entrato = true; attuale = -1; }
      mostra(i);
    }

    var inCoda = false;
    function chiedi() {
      if (inCoda) return;
      inCoda = true;
      setTimeout(function () { inCoda = false; aggiorna(); }, 60);
    }
    window.addEventListener('scroll', chiedi, { passive: true });
    window.addEventListener('resize', chiedi);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(chiedi);
    aggiorna();
  }

  /* ---------- premi: i filtri (come sulla pagina definitiva) ---------- */
  var grid = root.querySelector('[data-clb-grid]'), bar = root.querySelector('[data-clb-filters]'), none = root.querySelector('[data-clb-none]');
  if (grid && bar) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-kind]'));
    var chips = Array.prototype.slice.call(bar.querySelectorAll('[data-f]'));
    var adatta = function (el, f) { return f === 'all' || (f === 'ready' ? el.hasAttribute('data-ready') : el.getAttribute('data-kind') === f); };
    chips.forEach(function (c) {
      var f = c.getAttribute('data-f'), n = cards.filter(function (el) { return adatta(el, f); }).length;
      c.querySelector('span').textContent = n;
      if (!n && f !== 'ready') c.hidden = true;
    });
    bar.addEventListener('click', function (e) {
      var c = e.target.closest('[data-f]');
      if (!c) return;
      var f = c.getAttribute('data-f'), visti = 0;
      chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
      cards.forEach(function (el) { var ok = adatta(el, f); el.hidden = !ok; if (ok) visti++; });
      if (none) none.hidden = visti > 0;
    });
    bar.hidden = false;
  }

  /* ---------- livelli: le altre righe del confronto ---------- */
  var cmp = root.querySelector('[data-clb-cmp]'), altre = root.querySelector('[data-clb-more]');
  if (cmp && altre) {
    altre.addEventListener('click', function () {
      var aperto = cmp.classList.toggle('is-open');
      altre.setAttribute('aria-expanded', aperto ? 'true' : 'false');
      altre.querySelector('span').textContent = altre.getAttribute(aperto ? 'data-less' : 'data-more');
    });
  }
  if (cmp && cmp.scrollWidth > cmp.clientWidth) {
    var tu = cmp.querySelector('.clb-cmp__row--head .is-you'), lab = cmp.querySelector('.clb-cmp__lab');
    if (tu && lab) cmp.scrollLeft = Math.max(0, tu.offsetLeft - lab.offsetWidth);
  }
})();
